import * as olLoadingstrategy from 'ol/loadingstrategy'
import VectorSource from 'ol/source/Vector'
import { GeoJSON } from 'ol/format'

const defaultParams = {
  SERVICE: 'WFS',
  version: '1.1.0',
  request: 'GetFeature',
  outputFormat: 'application/json'
}

const VectorWFS = function(opt_options) {
  const options = opt_options || {}
  const optionalParams = options.params || {}
  const projection = options.projection || 'EPSG:3006'
  const params = Object.assign(
    {},
    defaultParams,
    { srsname: projection },
    optionalParams
  )

  const urlParams = Object.keys(params)
    .map(k => `${k}=${params[k]}`)
    .join('&')
  VectorSource.call(this, {
    strategy: olLoadingstrategy.bbox,
    format: opt_options.format || new GeoJSON(),
    url: function(extent) {
      return `${options.url}?${urlParams}&bbox=${extent.join(
        ','
      )},${projection}`
    }
  })
}
var ol_ext_inherits = function(child, parent) {
  child.prototype = Object.create(parent.prototype)
  child.prototype.constructor = child
}
ol_ext_inherits(VectorWFS, VectorSource)

export default VectorWFS
